"use client";

import {
  getSearchRoute,
  NavigationMerchantFlags,
} from "@/utils/navigationBarUtils";
import { shouldHardNavigate } from "@/utils/hardNavigation";
import { useCallback } from "react";

interface UseNavSearchParams {
  pathName: string | null;
  merchant: NavigationMerchantFlags;
  searchQuery: string;
  searchParams: URLSearchParams | null;
  restaurantMfeEnabled?: boolean;
  push: (href: string) => void;
  setSearchFieldOpen: (open: boolean) => void;
}

/** Provides the navigation bar's search submission behavior. */
export const useNavSearch = ({
  pathName,
  merchant,
  searchQuery,
  searchParams,
  restaurantMfeEnabled,
  push,
  setSearchFieldOpen,
}: UseNavSearchParams) =>
  useCallback(
    (event: { key: string }) => {
      if (event.key !== "Enter") return;

      const params = new URLSearchParams(searchParams || "");
      if (searchQuery) {
        params.set("query", searchQuery);
      } else {
        params.delete("query");
      }
      const { route, requiresHardNavigation } = getSearchRoute(
        pathName,
        merchant,
        restaurantMfeEnabled
      );
      const destination = `${route}?${params.toString()}`;
      if (
        requiresHardNavigation ||
        shouldHardNavigate(destination, merchant)
      ) {
        globalThis.location.assign(destination);
      } else {
        push(destination);
      }
      setSearchFieldOpen(false);
    },
    [
      merchant,
      pathName,
      push,
      restaurantMfeEnabled,
      searchParams,
      searchQuery,
      setSearchFieldOpen,
    ]
  );
